// extracted by mini-css-extract-plugin
export default {"products":"fw-z","card":"gw-z","oosMessaging":"hw-z"};